export const SET_CONTRIES_FORECAST = "SET_CONTRIES_FORECAST";
export const SET_DATA_FORECAST = "SET_DATA_FORECAST";
export const SET_URL_EXPORT = "SET_URL_EXPORT";
export const SET_LOADING_APPLY_FORECAST = "SET_LOADING_APPLY_FORECAST";
export const SET_DATA_SORT_TERM = "SET_DATA_SORT_TERM";
export const SET_DATA_SORT_TERM_RESULT = "SET_DATA_SORT_TERM_RESULT";
export const SET_DATA_SORT_TERM_RESULT_ENDOGENIZE =
  "SET_DATA_SORT_TERM_RESULT_ENDOGENIZE";
